export const replacePlaceholders = (input: string, data: Record<string, string>) => {
  let returnValue = input ?? "";
  for (const [key, value] of Object.entries(data)) {
    returnValue = returnValue.split(`{${key}}`).join(value);
  }

  return returnValue;
};
